import React, { useState } from "react";
import { Paper, CssBaseline, Button } from "@material-ui/core";
import { useStyle } from "./styles";

import { Drawer } from "@mui/material";

export default function MaterialLayout(props) {
  const { children, activeStepColor, open } = props;
  const classes = useStyle();

  return (
    <>
      <Drawer className={classes.drawerClass} anchor="right" open={open}>
        <CssBaseline />
        <div className={classes.root}>
          <Paper
            style={{
              backgroundColor: activeStepColor,
            }}
            className={classes.paper}
          >
            {" "}
            {children}
          </Paper>
        </div>
      </Drawer>
    </>
  );
}
